export default "__VITE_ASSET__BpK1CSHS__"